import {
  Button,
  Heading,
  IconWithText,
  Image,
  ImageWithText,
  ImageWithText2,
  ImageWithText3,
  LinkList,
  List as ListModel,
  PostContent,
  Table,
  Text,
  Video,
} from "../models/post";
import React, { useState } from "react";
import HorizontalAlignment from "../models/horizontal-alignment";
import HeadingComponent from "./heading-component";
import TextComponent from "./text-component";
import ImageComponent from "./image-component";
import ListComponent from "./list-component";
import { LinkListComponent } from "./link-list-component";
import { IconTextComponent } from "./icon-text-component";
import ImageAlignment from "../models/image-alignment";
import { ImageTextComponent } from "./image-text-component";
import { ImageText2Component } from "./image-text-2-component";
import { ImageText3Component } from "./image-text-3-component";
import { VideoComponent } from "./video-component";
import { Div, Wrapper } from "./post-components";
import styled from "styled-components";
import ButtonComponent from "./button-component";
import TableComponent from "./table-component";

function ContentChild(props: {
  content: PostContent;
  setContent: React.Dispatch<React.SetStateAction<PostContent[]>>;
  index: number;
  deleteContent: () => void;
}) {
  const { content, setContent, index } = props;
  if (content.type === "heading") {
    const heading = content.value as Heading;
    const updateHeading = (
      text: string,
      alignment: HorizontalAlignment,
      size: "1" | "2" | "3"
    ) => {
      const newHeading: Heading = {
        alignment,
        size,
        text,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "heading",
          value: newHeading,
        };
        return c;
      });
    };
    return (
      <Wrapper>
        <HeadingComponent
          heading={heading}
          update={updateHeading}
          deleteContent={props.deleteContent}
        />
      </Wrapper>
    );
  }
  if (content.type === "text") {
    const text = content.value as Text;
    const updateText = (text: string) => {
      const newText: Text = {
        text,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "text",
          value: newText,
        };
        return c;
      });
    };
    return (
      <div>
        <TextComponent
          text={text}
          update={updateText}
          deleteContent={props.deleteContent}
        />
      </div>
    );
  }
  if (content.type === "image") {
    const image = content.value as Image;
    if (!image.link) image.link = "";
    const updateImage = (
      src: string,
      alt: string,
      info: string,
      link: string
    ) => {
      const newImage: Image = {
        src,
        alt,
        info,
        link,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "image",
          value: newImage,
        };
        return c;
      });
    };
    return (
      <ImageComponent
        image={image}
        update={updateImage}
        deleteContent={props.deleteContent}
      />
    );
  }
  if (content.type === "list") {
    const list = content.value as ListModel;
    const updateList = (items: string[]) => {
      const newList: ListModel = {
        items,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "list",
          value: newList,
        };
        return c;
      });
    };
    return (
      <ListComponent
        list={list}
        update={updateList}
        deleteContent={props.deleteContent}
      />
    );
  }
  if (content.type === "list_with_links") {
    const linkList = content.value as LinkList;
    const updateLinkList = (items: { text: string; link: string }[]) => {
      const newLinkList: LinkList = {
        items,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "list_with_links",
          value: newLinkList,
        };
        return c;
      });
    };
    return (
      <LinkListComponent
        linkList={linkList}
        update={updateLinkList}
        deleteContent={props.deleteContent}
      />
    );
  }
  if (content.type === "icon_with_text") {
    const iconText = content.value as IconWithText;
    const updateIconText = (icon: string, text: string) => {
      const newIconText: IconWithText = {
        icon,
        text,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "icon_with_text",
          value: newIconText,
        };
        return c;
      });
    };
    return (
      <IconTextComponent
        iconWithText={iconText}
        update={updateIconText}
        deleteContent={props.deleteContent}
      />
    );
  }
  if (content.type === "image_with_text") {
    const imageText = content.value as ImageWithText;
    if (!imageText.image.link) imageText.image.link = "";
    const updateImageText = (
      image: Image,
      text: string,
      alignment: ImageAlignment
    ) => {
      const newImageText: ImageWithText = {
        image,
        text,
        alignment,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "image_with_text",
          value: newImageText,
        };
        return c;
      });
    };
    return (
      <ImageTextComponent
        imageWithText={imageText}
        update={updateImageText}
        deleteContent={props.deleteContent}
      />
    );
  }

  if (content.type === "image_with_text_2") {
    const imageText2 = content.value as ImageWithText2;

    if (!imageText2.image1.link) imageText2.image1.link = "";
    if (!imageText2.image2.link) imageText2.image2.link = "";

    const updateImageText2 = (
      image1: Image,
      image2: Image,
      text1: string,
      text2: string
    ) => {
      const newImageText2: ImageWithText2 = {
        image1,
        image2,
        text1,
        text2,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "image_with_text_2",
          value: newImageText2,
        };
        return c;
      });
    };
    return (
      <ImageText2Component
        imageWithText2={imageText2}
        update={updateImageText2}
        deleteContent={props.deleteContent}
      />
    );
  }

  if (content.type === "image_with_text_3") {
    const imageText3 = content.value as ImageWithText3;

    if (!imageText3.image1.link) imageText3.image1.link = "";
    if (!imageText3.image2.link) imageText3.image2.link = "";
    if (!imageText3.image3.link) imageText3.image3.link = "";

    const updateImageText3 = (
      image1: Image,
      image2: Image,
      image3: Image,
      text1: string,
      text2: string,
      text3: string
    ) => {
      const newImageText3: ImageWithText3 = {
        image1,
        image2,
        image3,
        text1,
        text2,
        text3,
      };
      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "image_with_text_3",
          value: newImageText3,
        };
        return c;
      });
    };
    return (
      <ImageText3Component
        imageWithText3={imageText3}
        update={updateImageText3}
        deleteContent={props.deleteContent}
      />
    );
  }
  if (content.type === "video") {
    const video = content.value as Video;
    return (
      <VideoComponent
        video={video}
        update={() => {}}
        deleteContent={props.deleteContent}
      />
    );
  }

  if (content.type === "button") {
    const button = content.value as Button;
    const updateButton = (label: string, link: string) => {
      const newButton: Button = {
        label,
        link,
      };

      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "button",
          value: newButton,
        };
        return c;
      });
    };

    return (
      <ButtonComponent
        button={button}
        update={updateButton}
        deleteContent={props.deleteContent}
      />
    );
  }
  if (content.type === "table") {
    const table = content.value as Table;
    const updateTable = (columns: string[][]) => {
      const newTable: Table = {
        columnCount: columns.length,
        columns,
      };

      setContent((c) => {
        c[index] = {
          key: c[index].key,
          type: "table",
          value: newTable,
        };
        return c;
      });
    };

    return (
      <TableComponent
        table={table}
        update={updateTable}
        deleteContent={props.deleteContent}
      />
    );
  }
  return <div></div>;
}

const BeforeButton = styled.div`
  position: absolute;
  z-index: 1;
  top: 0;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -50%);
  height: 25px;
  font-size: 0.8rem;
  border-radius: 20px;
  padding: 0 1rem;
  cursor: pointer;
  background: #0398fc;
  color: white;
  text-decoration: none;
  opacity: ${({ show }: { show: boolean }) => (show ? "1" : "0")};
  transition: 0.2s;
`;
const AfterButton = styled.div`
  position: absolute;
  z-index: 1;
  top: 100%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transform: translate(-50%, -75%);
  height: 25px;
  font-size: 0.8rem;
  border-radius: 20px;
  padding: 0 1rem;
  cursor: pointer;
  background: #0398fc;
  color: white;
  text-decoration: none;
  opacity: ${({ show }: { show: boolean }) => (show ? "1" : "0")};
  transition: 0.2s;
`;

export default function ContentComponent(props: {
  content: PostContent;
  setContent: React.Dispatch<React.SetStateAction<PostContent[]>>;
  index: number;
  deleteContent: () => void;
  onBeforeAdd: () => void;
  onAfterAdd: () => void;
}) {
  const [showButtons, setShowButtons] = useState(false);
  return (
    <Div
      onMouseEnter={() => setShowButtons(true)}
      onMouseLeave={() => setShowButtons(false)}
      onMouseMove={() => setShowButtons(true)}
    >
      <BeforeButton show={showButtons} onClick={props.onBeforeAdd}>
        Hinzufügen
      </BeforeButton>
      <ContentChild {...props} />
      <AfterButton show={showButtons} onClick={props.onAfterAdd}>
        Hinzufügen
      </AfterButton>
    </Div>
  );
}
